import React, { useState } from "react";
import { isJaguar, hasClientAccess } from "@/utility/UserUtils";
import { Button } from "@mui/material";
import CreateNewItemSearchModal from "@/items/form/CreateNewItemSearchModal";

const AddNewItemButton = ({
  user,
  onClose = () => {},
  renter,
  items,
  disabled,
  loadItems
}) => {
  const [createNewItemModalOpen, setCreateNewItemModalOpen] = useState(false);

  const handleCloseCreateNewItemModal = () => {
    setCreateNewItemModalOpen(false);
    onClose();
  }

  if(hasClientAccess(user,renter)) {
    return (
      <>
        <CreateNewItemSearchModal 
          open={createNewItemModalOpen}
          onClose={handleCloseCreateNewItemModal}
          user={user}
          items={items}
          renter={renter}
          loadItems={loadItems}
        />
        <Button
          disabled={disabled}
          variant="contained"
          color={renter && renter.id != 'all' ? "clientblue" : "green"}
          onClick={() => setCreateNewItemModalOpen(true)}
        >
          Create New Item
        </Button>
      </>
    )
  }
}

export default AddNewItemButton